import React, { useState, useEffect, useRef } from 'react';
import introJs from 'intro.js';
import 'intro.js/introjs.css';

// 1. DEFINICIÓN DE ESTILOS PREMIUM
const TOUR_STYLES = `
  .welcome-modal-overlay {
    position: fixed;
    top: 0; left: 0; width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(8px);
    display: flex; align-items: center; justify-content: center;
    z-index: 10000000;
    animation: tourFadeIn 0.3s ease-out;
  }
  @keyframes tourFadeIn { from { opacity: 0; } to { opacity: 1; } }

  .welcome-modal-card {
    background: white; width: 90%; max-width: 500px;
    border-radius: 20px; overflow: hidden;
    box-shadow: 0 25px 50px rgba(0,0,0,0.5);
    animation: tourSlideUp 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  }
  @keyframes tourSlideUp { from { transform: translateY(60px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

  .welcome-modal-header {
    background: #003366; color: white; padding: 30px;
    text-align: center; border-bottom: 4px solid #ffc107;
  }
  .welcome-modal-header h2 { margin: 0; font-size: 1.6rem; font-weight: 700; color: white !important; }

  .welcome-modal-body { padding: 35px; color: #333; line-height: 1.6; font-size: 1.15rem; text-align: center; }
  .welcome-modal-footer { padding: 10px 35px 40px; display: flex; flex-direction: column; gap: 15px; }

  .btn-start-tour {
    background: #003366; color: white; border: none; padding: 16px;
    border-radius: 10px; font-weight: bold; cursor: pointer; font-size: 1.1rem;
    transition: all 0.2s; box-shadow: 0 4px 12px rgba(0,51,102,0.3);
  }
  .btn-start-tour:hover { background: #004a94; transform: translateY(-2px); color: white; }

  .btn-skip-tour {
    background: transparent; color: #666; border: 2px solid #eee; padding: 14px;
    border-radius: 10px; font-weight: 500; cursor: pointer; font-size: 1rem;
    transition: all 0.2s;
  }
  .btn-skip-tour:hover { background: #f8f9fa; border-color: #ddd; color: #333; }

  .custom-tooltip-style {
    max-width: 380px !important; width: 380px !important;
    border-radius: 15px !important; padding: 20px !important;
    box-shadow: 0 15px 40px rgba(0,0,0,0.2) !important;
    border: none !important; background: white !important;
  }

  .introjs-tooltip-title {
    font-family: 'Outfit', sans-serif !important;
    font-weight: 700 !important; font-size: 1.3rem !important;
    margin-bottom: 15px !important; display: block !important; color: #003366 !important;
  }

  .introjs-tooltiptext {
    font-family: 'Inter', sans-serif !important; font-size: 1rem !important;
    line-height: 1.6 !important; color: #444 !important;
  }

  .introjs-button {
    border-radius: 8px !important; padding: 10px 20px !important;
    font-weight: 600 !important; transition: all 0.2s ease !important;
    text-shadow: none !important; box-shadow: none !important;
  }

  .introjs-nextbutton { background: #003366 !important; color: white !important; border: none !important; }
  .introjs-prevbutton { background: #f0f0f0 !important; color: #666 !important; border: 1px solid #ddd !important; }
  .introjs-bullets ul li a.active { background: #003366 !important; }
  .introjs-progress { height: 6px !important; background-color: #eee !important; }
  .introjs-progressbar { background-color: #007bff !important; }
  .introjs-skipbutton {
    display: block !important; color: #999 !important; font-size: 22px !important;
    font-weight: bold !important; text-decoration: none !important;
    position: absolute !important; top: 5px !important; right: 12px !important;
    cursor: pointer !important; line-height: 1 !important;
  }
  .introjs-skipbutton:hover { color: #d9534f !important; }

  /* Asegurar que el elemento resaltado sea clicable y visible (FIX GRISADO) */
  .introjs-showElement {
    z-index: 10000001 !important;
    position: relative !important;
    pointer-events: auto !important;
    opacity: 1 !important;
    filter: none !important;
  }

  /* FIX GRISADO: el elemento resaltado y TODOS sus hijos deben verse con color normal */
  .introjs-showElement,
  .introjs-showElement * {
    opacity: 1 !important;
    filter: none !important;
    color: inherit !important;
  }

  /* Spotlight: la capa de ayuda usa box-shadow extendido para crear el efecto oscuro alrededor */
  .introjs-helperLayer {
    box-shadow: 0 0 0 2000px rgba(0, 0, 0, 0.6), 0 0 15px rgba(0,0,0,0.5) !important;
    border: 2px solid rgba(255, 255, 255, 0.5) !important;
    background: transparent !important;
    pointer-events: none !important;
  }

  .introjs-tooltipReferenceLayer {
    pointer-events: none !important;
  }

  .introjs-disableInteraction {
    display: none !important;
    pointer-events: none !important;
  }

  /* FIX: Eliminar el stacking context de contenedores problemáticos */
  body.ifop-tour-active .z-2,
  body.ifop-tour-active .overlay,
  body.ifop-tour-active .position-relative,
  body.ifop-tour-active .margin_main,
  body.ifop-tour-active .video-header,
  body.ifop-tour-active .video-overlay,
  body.ifop-tour-active .card,
  body.ifop-tour-active .custom-card,
  body.ifop-tour-active .card-body,
  body.ifop-tour-active .row,
  body.ifop-tour-active [class*="col-"],
  body.ifop-tour-active header,
  body.ifop-tour-active main,
  body.ifop-tour-active #acuicultura-v1-root,
  body.ifop-tour-active .fondo-gris,
  body.ifop-tour-active .buscador-avanzado {
    z-index: auto !important;
    transform: none !important;
    opacity: 1 !important;
    filter: none !important;
    isolation: auto !important;
  }

  body.ifop-tour-active .overlay::before {
    display: none !important;
    opacity: 0 !important;
  }

  /* Tooltip desplazado a la DERECHA dentro del contenedor de resultados */
  .tooltip-offset-right.introjs-tooltip {
    left: auto !important;
    right: 20px !important;
    margin-left: 0 !important;
    transform: none !important;
  }

  /* El overlay se oculta: el efecto oscuro lo hace el box-shadow del helperLayer */
  .introjs-overlay {
    opacity: 0 !important;
    pointer-events: none !important;
  }

  /* Evitar animaciones de redibujado entre pasos con el mismo target */
  .introjs-helperLayer {
    transition: none !important;
    animation: none !important;
  }

  .introjs-tooltip {
    pointer-events: auto !important;
    z-index: 10000005 !important;
  }

  /* MEJORAS RESPONSIVAS PARA MÓVILES (v31 - Ultra Compacto) */
  @media (max-width: 768px) {
    .custom-tooltip-style {
      width: calc(100vw - 50px) !important;
      max-width: 280px !important;
      min-width: auto !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      margin: 5px 0 !important;
      padding: 8px 12px !important;
      height: auto !important;
      min-height: auto !important;
    }

    .introjs-tooltip-title { 
      font-size: 0.9rem !important; 
      margin-bottom: 3px !important;
    }
    
    .introjs-tooltiptext { 
      font-size: 0.8rem !important; 
      line-height: 1.2 !important;
      padding: 2px 0 !important;
    }

    .tour-validation-msg {
      font-size: 0.75rem !important;
    }

    .introjs-tooltipReferenceLayer {
      width: 100% !important;
      left: 0 !important;
    }

    .introjs-helperLayer {
      box-shadow: 0 0 0 1000vh rgba(0,0,0,0.3) !important;
      border: 2px solid #ffc107 !important;
    }

    .introjs-tooltipbuttons {
      padding: 4px !important;
      margin-top: 4px !important;
    }
    
    .introjs-button {
      padding: 3px 8px !important;
      font-size: 0.75rem !important;
    }

    .introjs-bullets {
      display: none !important;
    }
  }

  /* Ajuste para que el pop-up de la etapa 6 esté ligeramente más arriba */
  .step-descarga-final .introjs-tooltip {
    margin-bottom: 20px !important;
  }

  html, body {
    scroll-behavior: auto !important;
  }
`;

const TourGuiaPublico = ({ 
  enabled: enabledProp, 
  onExit,
  onAutoFillEspecie,
  onAutoFillAnio,
  onAutoFillRegion
}) => {
  const [showWelcome, setShowWelcome] = useState(false);
  const isStartedRef = useRef(false);
  const tourRef = useRef(null);

  // A. INYECCIÓN DE ESTILOS — Tour Buscador Público y Acuicultura (/buscador/buscador-publico, /buscador/acuicultura)
  useEffect(() => {
    const styleId = 'ifop-tour-publico-acuicultura-v36';
    // Limpiar residuos
    const oldStyles = document.querySelectorAll('[id^="ifop-tour-publico-acuicultura-"]');
    oldStyles.forEach(el => {
      if (el.id !== styleId) el.remove();
    });

    if (!document.getElementById(styleId)) {
      const styleEl = document.createElement('style');
      styleEl.id = styleId;
      styleEl.innerHTML = TOUR_STYLES;
      document.head.appendChild(styleEl);
    }
  }, []);

  // B. LIMPIEZA DE RESIDUOS
  const cleanTourGarbage = () => {
    document.body.classList.remove('introjs-showElement', 'introjs-relativeElement', 'introjs-fixParent', 'ifop-tour-active');
    const garbage = document.querySelectorAll('.introjs-overlay, .introjs-helperLayer, .introjs-tooltipReferenceLayer, .introjs-hints');
    garbage.forEach(el => el.remove());
  };

  // C. CONTROL DE PERSISTENCIA
  useEffect(() => {
    const hasSeenTour = localStorage.getItem('ifop_tour_publico_v4');

    if (enabledProp) {
      cleanTourGarbage();
      startTour();
    } else if (!hasSeenTour) {
      const timer = setTimeout(() => {
        setShowWelcome(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [enabledProp]);

  // D. LOGICA DE INICIO
  const startTour = () => {
    if (isStartedRef.current) return;
    setShowWelcome(false);
    cleanTourGarbage();
    introJs().exit(true);

    document.body.classList.add('ifop-tour-active');

    const tour = introJs();
    tourRef.current = tour;

    tour.setOptions({
      nextLabel: 'Siguiente',
      prevLabel: 'Anterior',
      doneLabel: 'Finalizar',
      showSkipButton: true,
      skipLabel: '×',
      hidePrev: true,
      showProgress: true,
      showBullets: true,
      exitOnOverlayClick: false,
      overlayOpacity: 0.6, // Forzar opacidad explícitamente
      scrollToElement: true,
      scrollPadding: window.innerWidth < 768 ? 200 : 100, /* Más espacio para tooltip arriba */
      tooltipClass: 'custom-tooltip-style',
      disableInteraction: false,
      steps: [
        {
          element: '#tour-pub-tipo-informacion',
          intro: '<b style="color: #003366; font-size: 1.1rem;">1. Selecciona la Información</b><br/><br/>Elige el tipo de información que deseas consultar.<br/><br/><i class="tour-validation-msg" style="color: #ff0000; font-size: 0.85rem; display: none;">* Se requiere agregar la selección para continuar.</i>',
          position: window.innerWidth < 768 ? 'top' : 'right',
        },
        {
          element: '#tour-pub-anio',
          intro: '<b style="color: #003366; font-size: 1.1rem;">2. Elige el Período</b><br/><br/>Selecciona el año de interés para tu búsqueda.<br/><br/><i class="tour-validation-msg" style="color: #ff0000; font-size: 0.85rem; display: none;">* Se requiere agregar la selección para continuar.</i>',
          position: window.innerWidth < 768 ? 'top' : 'right',
        },
        {
          element: '#tour-pub-region',
          intro: '<b style="color: #003366; font-size: 1.1rem;">3. Filtra por Región</b><br/><br/>Indica la zona geográfica de los datos.<br/><br/><i class="tour-validation-msg" style="color: #ff0000; font-size: 0.85rem; display: none;">* Se requiere agregar la selección para continuar.</i>',
          position: window.innerWidth < 768 ? 'top' : 'left',
        },
        {
          element: '#tour-pub-buscar',
          intro: '<b style="color: #d9534f; font-size: 1.1rem;">4. ¡Busca los Datos!</b><br/><br/>Haz clic aquí para procesar tus filtros y ver los resultados.<br/><br/><i class="tour-validation-msg" style="color: #ff0000; font-size: 0.85rem; display: none;">* Por favor, completa los filtros obligatorios para continuar.</i>',
          position: window.innerWidth < 768 ? 'top' : 'left',
        },
        {
          element: '#tour-pub-resultados-container',
          intro: '<b style="color: #003366; font-size: 1.1rem;">5. Explora y Descarga</b><br/><br/>Aquí aparecerán los resultados consolidados. Selecciona los tipos de información para habilitar la descarga y verás cómo se despliega la tabla inferior.',
          position: window.innerWidth < 768 ? 'top' : 'right',
          tooltipClass: 'custom-tooltip-style tooltip-offset-right',
          disableInteraction: false,
        },
        {
          element: '#tour-pub-resultados-container',
          intro: '<b style="color: #003366; font-size: 1.1rem;">6. Descarga Final</b><br/><br/>¡Aquí tienes tus archivos! Puedes descargar registros individuales en <b>XLSX</b> o un <b>ZIP consolidado</b> con toda tu selección.',
          position: window.innerWidth < 768 ? 'top' : 'right',
          tooltipClass: 'custom-tooltip-style step-descarga-final tooltip-offset-right',
          disableInteraction: false,
        }
      ]
    });

    // Lógica de Validación Universal (Igual que Buscador Experto v25)
    let searchValidator = null;

    tour.onbeforechange(function (targetElement) {
      tour.refresh();
      const targetId = targetElement ? targetElement.getAttribute('id') : null;

      // Limpiar validadores previos
      if (searchValidator) clearInterval(searchValidator);

      // Bloquear scroll automático para los resultados y descargas (Petición usuario)
      if (targetId === 'tour-pub-resultados-container' || targetId === 'tour-pub-tabla-descargas' || targetId === 'tour-pub-boton-descarga-grupal') {
        tour.setOption('scrollToElement', false);
      } else {
        tour.setOption('scrollToElement', true);
      }

      // LÓGICA DE VALIDACIÓN (NUEVA PORTABILIDAD v25)
      const validatorIds = ['tour-pub-tipo-informacion', 'tour-pub-anio', 'tour-pub-region', 'tour-pub-buscar'];
      if (validatorIds.includes(targetId)) {
        // Pequeño delay de 100ms para asegurar que el DOM de Intro.js esté listo en el Paso 1
        setTimeout(() => {
          if (searchValidator) clearInterval(searchValidator); // Doble seguridad
          
          searchValidator = setInterval(() => {
            const nextBtn = document.querySelector('.introjs-nextbutton');
            const validationMsg = document.querySelector('.tour-validation-msg');
            const container = document.getElementById(targetId);
            
            let isValid = false;

            switch (targetId) {
              case 'tour-pub-tipo-informacion':
                isValid = container ? container.querySelectorAll('.select__multi-value').length > 0 : false;
                break;
              case 'tour-pub-anio':
              case 'tour-pub-region':
                // Verificar si react-select tiene valor (usando la clase select__single-value configurada en page.jsx)
                isValid = container ? container.querySelectorAll('.select__single-value').length > 0 : false;
                break;
              case 'tour-pub-buscar':
                // Verificar si ya existen resultados en el contenedor (Cards de datos)
                const resContainer = document.getElementById('tour-pub-resultados-container');
                isValid = resContainer ? resContainer.querySelector('#tour-pub-primer-card') !== null : false;
                break;
              default:
                isValid = true;
            }

            if (nextBtn) {
              if (!isValid) {
                nextBtn.style.opacity = '0.4';
                nextBtn.style.pointerEvents = 'none';
                if (validationMsg) validationMsg.style.display = 'block';
              } else {
                nextBtn.style.opacity = '1';
                nextBtn.style.pointerEvents = 'auto';
                if (validationMsg) validationMsg.style.display = 'none';
              }
            }
          }, 500);
        }, 100);
      }

      // Al entrar al contenedor de resultados (Paso 5)
      if (targetId === 'tour-pub-resultados-container' && tour._currentStep === 4) {
        const lastScrollY = window.scrollY; // Guardar posición

        return new Promise((resolve) => {
          // Trigger search first
          const btn = document.querySelector('#tour-pub-buscar button');
          if (btn && !btn.disabled) {
            console.log("[TourDebug] Reached Results Step: Clicking Search...");
            btn.click();
          }

          let attempts = 0;
          const timer = setInterval(() => {
            attempts++;
            const selector = '#tour-pub-primer-card';
            const el = document.querySelector(selector);
            if ((el && el.offsetHeight > 50) || attempts > 25) {
              clearInterval(timer);
              console.log("[TourDebug] Results detected. Selecting download automatically...");
              
              // AUTO-CLICK CHECKBOX PARA ACTIVAR DESCARGAS (Petición usuario)
              setTimeout(() => {
                const firstCheck = el ? el.querySelector('input[type="checkbox"]') : null;
                if (firstCheck && !firstCheck.checked) {
                  firstCheck.click();
                }
                
                // Forzar que el scroll no se mueva tras renderizado
                window.scrollTo(0, lastScrollY);
                resolve();
              }, 300);
            }
          }, 400);
        });
      }

      // Step 6: Mantenerse en el mismo sitio que el Paso 5
      if (targetId === 'tour-pub-resultados-container' && tour._currentStep === 5) {
        return Promise.resolve();
      }

      return Promise.resolve();
    });

    // LOCK DEFINITIVO DE SCROLL EN EL CAMBIO 5 -> 6
    let step5ScrollPosition = 0;
    tour.onafterchange(function (targetElement) {
      if (tour._currentStep === 4) { // Paso 5
        step5ScrollPosition = window.scrollY;
      }
      if (tour._currentStep === 5) { // Paso 6
        window.scrollTo(0, step5ScrollPosition);
      }

    });

    tour.oncomplete(() => {
      if (searchValidator) clearInterval(searchValidator);
      isStartedRef.current = false;
      localStorage.setItem('ifop_tour_publico_v4', 'true');
      if (onExit) onExit();
    });

    tour.onexit(() => {
      if (searchValidator) clearInterval(searchValidator);
      isStartedRef.current = false;
      if (onExit) onExit();
    });

    tour.start();
    isStartedRef.current = true;
  };

  const handleSkipWelcome = () => {
    setShowWelcome(false);
    localStorage.setItem('ifop_tour_publico_v4', 'true');
    if (onExit) onExit();
  };

  if (!showWelcome && !isStartedRef.current) return null;

  return (
    <>
      {showWelcome && (
        <div className="welcome-modal-overlay">
          <div className="welcome-modal-card">
            <div className="welcome-modal-header">
              <h2>¡Bienvenido al Buscador Público!</h2>
            </div>
            <div className="welcome-modal-body">
              <p>¿Te gustaría realizar un breve recorrido guiado por las funciones principales de este portal?</p>
            </div>
            <div className="welcome-modal-footer">
              <button className="btn-start-tour" onClick={startTour}>
                Iniciar Recorrido
              </button>
              <button className="btn-skip-tour" onClick={handleSkipWelcome}>
                Quizás más tarde
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TourGuiaPublico;
